"use client";

import { mapToJsonLd } from "../../utils/structuredData/mapToJsonLd";

type StructuredDataProps = {
    data: Record<string, any>;
};

export default function StructuredData({ data }: StructuredDataProps) {
    const formattedData = mapToJsonLd(data);

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(formattedData, null, 2),
            }}
        />
    );
}
